module.exports = __webpack_public_path__ + "img/mstile-150x150.6b20ba40.png";